import React from 'react';
import styled from 'styled-components';
import { FaTrash } from 'react-icons/fa';

class OrganizationListItem extends React.Component {

    constructor(props) {
        super(props);
        this.container = styled.li `
            background-color: #fff;
            display: ${props => props.small ? 'inline-block' : 'block'};
            margin: ${props => props.small ? '0 8px 8px 0' : '0'};
            border-radius: ${props => props.small ? '4px' : 'unset'};
            width: ${props => props.small ? '160px' : 'initial'};
            .task_info_block{
                width: 80%;
                padding: ${props => props.small ? '8px 16px' : '14px 20px'};
            }
            .org_remove_block{
                padding: 0 12px;
                border-left: 1px solid ${props => props.theme.colors.border};
                width: 20%;
                text-align: center;
                cursor: pointer;
                opacity: 0.7;
                &:HOVER{
                    opacity: 1;
                }
            }

            .task_info_block, .org_remove_block{
                display: inline-block;
                vertical-align: middle;
            }

            .task_title{
                font-weight: bold;
                font-size: 14px;
            }
            .task_description{
                white-space: nowrap;
                font-size: 12px;
                line-height: 16px;
                opacity: 0.5;
                overflow: hidden;
            }
        `;
    }

    renderTrash() {
        if (!this.props.onClickRemove) {
            return null;
        }

        return (
            <div
                className="org_remove_block"
                onClick={() => {
                    this.props.onClickRemove();
                }}
                >
                <FaTrash />
            </div>
        );
    }

    render() {
        return (
            <this.container small={this.props.small} className="task_list_item">
                <div
                    className="task_info_block"
                    onClick={() => {
                           this.props.onClickItem();
                       }}>
                    <p className="task_title">
                        {this.props.organization.name}
                    </p>
                    <p className="task_description">
                        {this.props.organization.subtitle}
                    </p>
                </div>
                { this.renderTrash() }
            </this.container>
        );
    }
}

export default OrganizationListItem;



// WEBPACK FOOTER //
// ./src/components/base/OrganizationListItem.jsx